<template>
  <Profile />
</template>

<script>
import Profile from '@/components/common/Profile.vue'

export default {
  name: 'ProfilePage',
  components: { Profile }
}
</script>

<style scoped>

</style>
